import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/analytics";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyASlYe034IlR3L_79zcyENAFWQhK34S8hI",
  authDomain: "content-generator-8ab05.firebaseapp.com",
  projectId: "content-generator-8ab05",
  storageBucket: "content-generator-8ab05.firebasestorage.app",
  messagingSenderId: "413247457282",
  appId: "1:413247457282:web:83bc918d214fac9b76bf1b",
  measurementId: "G-PRW4YWRG15",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  // Only initialize analytics if supported (i.e., in the browser)
  if (typeof window !== "undefined" && "measurementId" in firebaseConfig) {
    // isSupported() returns a Promise
    firebase.analytics.isSupported().then((supported) => {
      if (supported) {
        firebase.analytics();
      }
    });
  }
}

export default firebase;
